import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useParams, useSelector } from 'umi';
import { Text, Layout } from 'tea-component';
import Permission from '@/pages/dashboard/components/NoPermission';
import Loading from '@/pages/dashboard/components/Loadings';
import {
  checkReportIdWithName,
  getDashboardType,
  getPathFromDashboard,
} from '@/pages/dashboard/utils/utils';
import { getPdfCos } from '@/pages/dashboard/services/dashboard';
import { LOG_SYSTEM_TYPE, PAGE_TYPE_PDF } from '@/pages/dashboard/_config/constant';
import { buriedPoint } from '@/pages/home/utils/buriedPoint';

interface ReportInfoType {
  loading: boolean;
  noReport: boolean,
}

const { Content } = Layout;

const INIT_REPORT_INFO:ReportInfoType = {
  noReport: false,
  loading: false
};
export default (props: any) => {
  const [reportInfo, setReportInfo] = useState<ReportInfoType>({
    loading: false,
    noReport: false
  });
  const [iframeUrl,setIframeUrl] = useState('')
  const dashboardRef = useRef<any>(null);
  const { reportId } = useParams() as any;
  const { currentMenu, currentGame } = useSelector(state => {
    // @ts-ignore
    const { currentMenu, currentGame } = state.dashboard;
    return {
      currentMenu,
      currentGame
    }
  });

  const setState = (params = {}) => {
    setReportInfo({
      ...INIT_REPORT_INFO,
      ...params
    });
  }

  // iframe 处理
  const openIframeReport = () => {

    if (!reportId ||!currentGame ) {
      return;
    }
    if (!currentMenu || getDashboardType(currentMenu) !== PAGE_TYPE_PDF || !checkReportIdWithName(reportId, currentMenu?.name_en)) {
      return;
    }
    setState({
      loading: true
    });
    dashboardRef.current = currentMenu;
    // pdf类型的链接和url的一样,都是字段url
    const { url} = currentMenu;

    if (!url) {
      setState({
        noReport: true
      });
      return;
    }
    const params = {
      url:url || ''
    }
    const { game_code: gameCode } = currentGame;
    getPdfCos(params).then((data) => {
      console.log (url)
      const iframe = data || '';
      if (dashboardRef.current?.id !== currentMenu?.id) {
        return;
      }
      if (iframe) {
        // 默认全屏和收起左侧预览栏
        setIframeUrl(iframe + '#view=fitH,top&navpanes=0');
        // 打点
        const { id = '', name_en: nameEn } = currentMenu || {};
        const logObj = {
          pageId: id,
          menuId: id,
          pageName: nameEn,
          extInfo: nameEn,
          pagePath: getPathFromDashboard(currentMenu),
          uid: gameCode,
          typeId: LOG_SYSTEM_TYPE,
        };
        buriedPoint(logObj);
      } else {
        setState({
          noReport: true
        });
      }
      setState({
        loading: false
      });
    }, () => {
      if (dashboardRef.current?.id !== currentMenu?.id) {
        return;
      }
      setState({
        loading: false
      });
      setState({
        noReport: true
      });
    });
  }

  useEffect(() => {
    openIframeReport();
  }, [reportId, currentMenu]);

  const errorInfo = useMemo(() => {
    // 无报表
    if (reportInfo.noReport) {
      return <div style={{
        width: '100%',
        height: '100%',
        background: '#eee',
      }}>
        <Text style={{
          position: 'relative',
          top: '50%',
          display: 'block',
          textAlign: 'center',
          fontSize: 14,
          color: '#999'
        }}>This function is not open yet. Please look forward to it.</Text>
      </div>
    }
    return null;
  }, [currentMenu, reportId, reportInfo]);

  return (
    <>
      {
        errorInfo || <div className='dtb-db-iframe-wrap iframe-wrap-padding'>
          <iframe
            title="tableau"
            className='dtb-db-iframe'
            src={iframeUrl}
          />
        </div>
      }
    </>
  );
};
